import { ApiPaths } from './ApiPaths';
import BaseApi from './BaseApi';

/**
 * API for managing workflow information
 * @param {String} baseURL
 */
const create = (handleUnauthorized) => {  // this will change for prod deployment
    
    const api = BaseApi.create({
        timeout: 100000,
        unAuthorizedFunction: handleUnauthorized
    });

    const uploadApi = BaseApi.create({
        timeout: 100000,
        unAuthorizedFunction: handleUnauthorized,
        errorCodes: [400]
    });

    const downloadFileByType = (ticketId, documentType) => api.getBlob(ApiPaths.DOWNLOAD_FILE_BY_TYPE(ticketId, documentType));
    const uploadFile = (formData, config) => uploadApi.upload(ApiPaths.UPLOAD_FILE, formData, config);
    const downloadFile = (fileId) => api.getBlob(ApiPaths.DOWNLOAD_FILE(fileId));
    const downloadZip = (ticketId, zipFileName, fileList) => api.getBlob(ApiPaths.DOWNLOAD_ZIP(ticketId, zipFileName, fileList));

    const getFiles = async (ticketId) => {
        let fileList = [];
        let status = true;
        let pageIndex = 1;
        while (pageIndex && status) {
            let response = await api.get(ApiPaths.GET_FILES(ticketId, pageIndex));
            if (response?.status !== 200) {
                status = false;
                break;
            }
            fileList = fileList.concat(response.data?.items || [])
            if (!response.data.hasMoreItems) {
                break;
            }
            ++pageIndex;
        }
        return { status, fileList }
    }
    
    const deleteFile = (fileId) => api.deleteRequest(ApiPaths.DELETE_FILE(fileId));
    const updateFileInfo = (ticketId, I, request) => api.put(ApiPaths.UPDATE_FILE_INFO(ticketId, I), request);
    const recoverFile = (fileId) => api.put(ApiPaths.RECOVER_FILE(fileId));

    const cancelToken = BaseApi.cancelToken;
    const isCancel = (ex) => BaseApi.isCancel(ex);

    // Return back a collection of functions
    return {
        downloadFile,
        downloadFileByType,
        downloadZip,
        getFiles,
        deleteFile,
        updateFileInfo,
        uploadFile,
        recoverFile,
        cancelToken,
        isCancel
    }
}

// let's return back our create method as the default.
export default {
    create
}
